// source: core/protos/canvas_items_2d.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
var core_protos_material_pb = require('../../core/protos/material_pb.js');
goog.object.extend(proto, core_protos_material_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.ArrowEndShape', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasItem2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CanvasItem2d.ItemCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.CircleEndShape', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.DashEndShape', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.EndShape', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.EndShape.SealedValueOptionalCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.FillStyle', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.FreeformItem2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.LineItem2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.OvalItem2d', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.StrokeStyle', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CanvasItem2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.CanvasItem2d.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.CanvasItem2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CanvasItem2d.displayName = 'proto.vertexvis.protobuf.core.CanvasItem2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.LineItem2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.LineItem2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.LineItem2d.displayName = 'proto.vertexvis.protobuf.core.LineItem2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.OvalItem2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.OvalItem2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.OvalItem2d.displayName = 'proto.vertexvis.protobuf.core.OvalItem2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.FreeformItem2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.core.FreeformItem2d.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.core.FreeformItem2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.FreeformItem2d.displayName = 'proto.vertexvis.protobuf.core.FreeformItem2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.EndShape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.EndShape.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.EndShape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.EndShape.displayName = 'proto.vertexvis.protobuf.core.EndShape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.ArrowEndShape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.ArrowEndShape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.ArrowEndShape.displayName = 'proto.vertexvis.protobuf.core.ArrowEndShape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.CircleEndShape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.CircleEndShape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.CircleEndShape.displayName = 'proto.vertexvis.protobuf.core.CircleEndShape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.DashEndShape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.DashEndShape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.DashEndShape.displayName = 'proto.vertexvis.protobuf.core.DashEndShape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.FillStyle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.FillStyle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.FillStyle.displayName = 'proto.vertexvis.protobuf.core.FillStyle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.StrokeStyle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.StrokeStyle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.StrokeStyle.displayName = 'proto.vertexvis.protobuf.core.StrokeStyle';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.CanvasItem2d.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.ItemCase = {
  ITEM_NOT_SET: 0,
  LINE_2D: 1,
  OVAL: 2,
  FREEFORM: 3
};

/**
 * @return {proto.vertexvis.protobuf.core.CanvasItem2d.ItemCase}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.getItemCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.CanvasItem2d.ItemCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.CanvasItem2d.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CanvasItem2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CanvasItem2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasItem2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    line2d: (f = msg.getLine2d()) && proto.vertexvis.protobuf.core.LineItem2d.toObject(includeInstance, f),
    oval: (f = msg.getOval()) && proto.vertexvis.protobuf.core.OvalItem2d.toObject(includeInstance, f),
    freeform: (f = msg.getFreeform()) && proto.vertexvis.protobuf.core.FreeformItem2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CanvasItem2d;
  return proto.vertexvis.protobuf.core.CanvasItem2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CanvasItem2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.LineItem2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.LineItem2d.deserializeBinaryFromReader);
      msg.setLine2d(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.OvalItem2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.OvalItem2d.deserializeBinaryFromReader);
      msg.setOval(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.FreeformItem2d;
      reader.readMessage(value,proto.vertexvis.protobuf.core.FreeformItem2d.deserializeBinaryFromReader);
      msg.setFreeform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CanvasItem2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CanvasItem2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CanvasItem2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLine2d();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.LineItem2d.serializeBinaryToWriter
    );
  }
  f = message.getOval();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.OvalItem2d.serializeBinaryToWriter
    );
  }
  f = message.getFreeform();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.FreeformItem2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional LineItem2d line_2d = 1;
 * @return {?proto.vertexvis.protobuf.core.LineItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.getLine2d = function() {
  return /** @type{?proto.vertexvis.protobuf.core.LineItem2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.LineItem2d, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.LineItem2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.setLine2d = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.CanvasItem2d.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.clearLine2d = function() {
  return this.setLine2d(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.hasLine2d = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OvalItem2d oval = 2;
 * @return {?proto.vertexvis.protobuf.core.OvalItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.getOval = function() {
  return /** @type{?proto.vertexvis.protobuf.core.OvalItem2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.OvalItem2d, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.OvalItem2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.setOval = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.core.CanvasItem2d.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.clearOval = function() {
  return this.setOval(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.hasOval = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FreeformItem2d freeform = 3;
 * @return {?proto.vertexvis.protobuf.core.FreeformItem2d}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.getFreeform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.FreeformItem2d} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.FreeformItem2d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.FreeformItem2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d} returns this
*/
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.setFreeform = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.vertexvis.protobuf.core.CanvasItem2d.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.CanvasItem2d} returns this
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.clearFreeform = function() {
  return this.setFreeform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CanvasItem2d.prototype.hasFreeform = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.LineItem2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.LineItem2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LineItem2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    strokeStyle: (f = msg.getStrokeStyle()) && proto.vertexvis.protobuf.core.StrokeStyle.toObject(includeInstance, f),
    fillStyle: (f = msg.getFillStyle()) && proto.vertexvis.protobuf.core.FillStyle.toObject(includeInstance, f),
    startShape: (f = msg.getStartShape()) && proto.vertexvis.protobuf.core.EndShape.toObject(includeInstance, f),
    endShape: (f = msg.getEndShape()) && proto.vertexvis.protobuf.core.EndShape.toObject(includeInstance, f),
    startPosition: (f = msg.getStartPosition()) && core_protos_geometry_pb.Vector2d.toObject(includeInstance, f),
    endPosition: (f = msg.getEndPosition()) && core_protos_geometry_pb.Vector2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d}
 */
proto.vertexvis.protobuf.core.LineItem2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.LineItem2d;
  return proto.vertexvis.protobuf.core.LineItem2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.LineItem2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d}
 */
proto.vertexvis.protobuf.core.LineItem2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.StrokeStyle;
      reader.readMessage(value,proto.vertexvis.protobuf.core.StrokeStyle.deserializeBinaryFromReader);
      msg.setStrokeStyle(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.FillStyle;
      reader.readMessage(value,proto.vertexvis.protobuf.core.FillStyle.deserializeBinaryFromReader);
      msg.setFillStyle(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.EndShape;
      reader.readMessage(value,proto.vertexvis.protobuf.core.EndShape.deserializeBinaryFromReader);
      msg.setStartShape(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.EndShape;
      reader.readMessage(value,proto.vertexvis.protobuf.core.EndShape.deserializeBinaryFromReader);
      msg.setEndShape(value);
      break;
    case 5:
      var value = new core_protos_geometry_pb.Vector2d;
      reader.readMessage(value,core_protos_geometry_pb.Vector2d.deserializeBinaryFromReader);
      msg.setStartPosition(value);
      break;
    case 6:
      var value = new core_protos_geometry_pb.Vector2d;
      reader.readMessage(value,core_protos_geometry_pb.Vector2d.deserializeBinaryFromReader);
      msg.setEndPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.LineItem2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.LineItem2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.LineItem2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStrokeStyle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.StrokeStyle.serializeBinaryToWriter
    );
  }
  f = message.getFillStyle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.FillStyle.serializeBinaryToWriter
    );
  }
  f = message.getStartShape();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.EndShape.serializeBinaryToWriter
    );
  }
  f = message.getEndShape();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.EndShape.serializeBinaryToWriter
    );
  }
  f = message.getStartPosition();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      core_protos_geometry_pb.Vector2d.serializeBinaryToWriter
    );
  }
  f = message.getEndPosition();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      core_protos_geometry_pb.Vector2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional StrokeStyle stroke_style = 1;
 * @return {?proto.vertexvis.protobuf.core.StrokeStyle}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.getStrokeStyle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.StrokeStyle} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.StrokeStyle, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.StrokeStyle|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
*/
proto.vertexvis.protobuf.core.LineItem2d.prototype.setStrokeStyle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.clearStrokeStyle = function() {
  return this.setStrokeStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.hasStrokeStyle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FillStyle fill_style = 2;
 * @return {?proto.vertexvis.protobuf.core.FillStyle}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.getFillStyle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.FillStyle} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.FillStyle, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.FillStyle|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
*/
proto.vertexvis.protobuf.core.LineItem2d.prototype.setFillStyle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.clearFillStyle = function() {
  return this.setFillStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.hasFillStyle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EndShape start_shape = 3;
 * @return {?proto.vertexvis.protobuf.core.EndShape}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.getStartShape = function() {
  return /** @type{?proto.vertexvis.protobuf.core.EndShape} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.EndShape, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.EndShape|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
*/
proto.vertexvis.protobuf.core.LineItem2d.prototype.setStartShape = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.clearStartShape = function() {
  return this.setStartShape(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.hasStartShape = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EndShape end_shape = 4;
 * @return {?proto.vertexvis.protobuf.core.EndShape}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.getEndShape = function() {
  return /** @type{?proto.vertexvis.protobuf.core.EndShape} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.EndShape, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.EndShape|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
*/
proto.vertexvis.protobuf.core.LineItem2d.prototype.setEndShape = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.clearEndShape = function() {
  return this.setEndShape(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.hasEndShape = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Vector2d start_position = 5;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.getStartPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector2d, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
*/
proto.vertexvis.protobuf.core.LineItem2d.prototype.setStartPosition = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.clearStartPosition = function() {
  return this.setStartPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.hasStartPosition = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Vector2d end_position = 6;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.getEndPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector2d, 6));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
*/
proto.vertexvis.protobuf.core.LineItem2d.prototype.setEndPosition = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.LineItem2d} returns this
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.clearEndPosition = function() {
  return this.setEndPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.LineItem2d.prototype.hasEndPosition = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.OvalItem2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.OvalItem2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.OvalItem2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    strokeStyle: (f = msg.getStrokeStyle()) && proto.vertexvis.protobuf.core.StrokeStyle.toObject(includeInstance, f),
    fillStyle: (f = msg.getFillStyle()) && proto.vertexvis.protobuf.core.FillStyle.toObject(includeInstance, f),
    topLeft: (f = msg.getTopLeft()) && core_protos_geometry_pb.Vector2d.toObject(includeInstance, f),
    bottomRight: (f = msg.getBottomRight()) && core_protos_geometry_pb.Vector2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d}
 */
proto.vertexvis.protobuf.core.OvalItem2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.OvalItem2d;
  return proto.vertexvis.protobuf.core.OvalItem2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.OvalItem2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d}
 */
proto.vertexvis.protobuf.core.OvalItem2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.StrokeStyle;
      reader.readMessage(value,proto.vertexvis.protobuf.core.StrokeStyle.deserializeBinaryFromReader);
      msg.setStrokeStyle(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.FillStyle;
      reader.readMessage(value,proto.vertexvis.protobuf.core.FillStyle.deserializeBinaryFromReader);
      msg.setFillStyle(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector2d;
      reader.readMessage(value,core_protos_geometry_pb.Vector2d.deserializeBinaryFromReader);
      msg.setTopLeft(value);
      break;
    case 4:
      var value = new core_protos_geometry_pb.Vector2d;
      reader.readMessage(value,core_protos_geometry_pb.Vector2d.deserializeBinaryFromReader);
      msg.setBottomRight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.OvalItem2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.OvalItem2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.OvalItem2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStrokeStyle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.StrokeStyle.serializeBinaryToWriter
    );
  }
  f = message.getFillStyle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.FillStyle.serializeBinaryToWriter
    );
  }
  f = message.getTopLeft();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector2d.serializeBinaryToWriter
    );
  }
  f = message.getBottomRight();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      core_protos_geometry_pb.Vector2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional StrokeStyle stroke_style = 1;
 * @return {?proto.vertexvis.protobuf.core.StrokeStyle}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.getStrokeStyle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.StrokeStyle} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.StrokeStyle, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.StrokeStyle|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
*/
proto.vertexvis.protobuf.core.OvalItem2d.prototype.setStrokeStyle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.clearStrokeStyle = function() {
  return this.setStrokeStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.hasStrokeStyle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FillStyle fill_style = 2;
 * @return {?proto.vertexvis.protobuf.core.FillStyle}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.getFillStyle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.FillStyle} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.FillStyle, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.FillStyle|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
*/
proto.vertexvis.protobuf.core.OvalItem2d.prototype.setFillStyle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.clearFillStyle = function() {
  return this.setFillStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.hasFillStyle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector2d top_left = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.getTopLeft = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector2d, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
*/
proto.vertexvis.protobuf.core.OvalItem2d.prototype.setTopLeft = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.clearTopLeft = function() {
  return this.setTopLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.hasTopLeft = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Vector2d bottom_right = 4;
 * @return {?proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.getBottomRight = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector2d} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector2d, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector2d|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
*/
proto.vertexvis.protobuf.core.OvalItem2d.prototype.setBottomRight = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OvalItem2d} returns this
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.clearBottomRight = function() {
  return this.setBottomRight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OvalItem2d.prototype.hasBottomRight = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.core.FreeformItem2d.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.FreeformItem2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.FreeformItem2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.FreeformItem2d.toObject = function(includeInstance, msg) {
  var f, obj = {
    strokeStyle: (f = msg.getStrokeStyle()) && proto.vertexvis.protobuf.core.StrokeStyle.toObject(includeInstance, f),
    fillStyle: (f = msg.getFillStyle()) && proto.vertexvis.protobuf.core.FillStyle.toObject(includeInstance, f),
    positionsList: jspb.Message.toObjectList(msg.getPositionsList(),
    core_protos_geometry_pb.Vector2d.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.FreeformItem2d;
  return proto.vertexvis.protobuf.core.FreeformItem2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.FreeformItem2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.StrokeStyle;
      reader.readMessage(value,proto.vertexvis.protobuf.core.StrokeStyle.deserializeBinaryFromReader);
      msg.setStrokeStyle(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.FillStyle;
      reader.readMessage(value,proto.vertexvis.protobuf.core.FillStyle.deserializeBinaryFromReader);
      msg.setFillStyle(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector2d;
      reader.readMessage(value,core_protos_geometry_pb.Vector2d.deserializeBinaryFromReader);
      msg.addPositions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.FreeformItem2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.FreeformItem2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.FreeformItem2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStrokeStyle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.StrokeStyle.serializeBinaryToWriter
    );
  }
  f = message.getFillStyle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.FillStyle.serializeBinaryToWriter
    );
  }
  f = message.getPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      core_protos_geometry_pb.Vector2d.serializeBinaryToWriter
    );
  }
};


/**
 * optional StrokeStyle stroke_style = 1;
 * @return {?proto.vertexvis.protobuf.core.StrokeStyle}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.getStrokeStyle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.StrokeStyle} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.StrokeStyle, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.StrokeStyle|undefined} value
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d} returns this
*/
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.setStrokeStyle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d} returns this
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.clearStrokeStyle = function() {
  return this.setStrokeStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.hasStrokeStyle = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FillStyle fill_style = 2;
 * @return {?proto.vertexvis.protobuf.core.FillStyle}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.getFillStyle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.FillStyle} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.FillStyle, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.FillStyle|undefined} value
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d} returns this
*/
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.setFillStyle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d} returns this
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.clearFillStyle = function() {
  return this.setFillStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.hasFillStyle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Vector2d positions = 3;
 * @return {!Array<!proto.vertexvis.protobuf.core.Vector2d>}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.getPositionsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.core.Vector2d>} */ (
    jspb.Message.getRepeatedWrapperField(this, core_protos_geometry_pb.Vector2d, 3));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.core.Vector2d>} value
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d} returns this
*/
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.setPositionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.vertexvis.protobuf.core.Vector2d=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.core.Vector2d}
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.addPositions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vertexvis.protobuf.core.Vector2d, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.core.FreeformItem2d} returns this
 */
proto.vertexvis.protobuf.core.FreeformItem2d.prototype.clearPositionsList = function() {
  return this.setPositionsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.EndShape.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.EndShape.SealedValueOptionalCase = {
  SEALED_VALUE_OPTIONAL_NOT_SET: 0,
  ARROW: 1,
  CIRCLE: 2,
  DASH: 3
};

/**
 * @return {proto.vertexvis.protobuf.core.EndShape.SealedValueOptionalCase}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.getSealedValueOptionalCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.EndShape.SealedValueOptionalCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.EndShape.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.EndShape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.EndShape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.EndShape.toObject = function(includeInstance, msg) {
  var f, obj = {
    arrow: (f = msg.getArrow()) && proto.vertexvis.protobuf.core.ArrowEndShape.toObject(includeInstance, f),
    circle: (f = msg.getCircle()) && proto.vertexvis.protobuf.core.CircleEndShape.toObject(includeInstance, f),
    dash: (f = msg.getDash()) && proto.vertexvis.protobuf.core.DashEndShape.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.EndShape}
 */
proto.vertexvis.protobuf.core.EndShape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.EndShape;
  return proto.vertexvis.protobuf.core.EndShape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.EndShape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.EndShape}
 */
proto.vertexvis.protobuf.core.EndShape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.ArrowEndShape;
      reader.readMessage(value,proto.vertexvis.protobuf.core.ArrowEndShape.deserializeBinaryFromReader);
      msg.setArrow(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.CircleEndShape;
      reader.readMessage(value,proto.vertexvis.protobuf.core.CircleEndShape.deserializeBinaryFromReader);
      msg.setCircle(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.DashEndShape;
      reader.readMessage(value,proto.vertexvis.protobuf.core.DashEndShape.deserializeBinaryFromReader);
      msg.setDash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.EndShape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.EndShape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.EndShape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArrow();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.ArrowEndShape.serializeBinaryToWriter
    );
  }
  f = message.getCircle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.CircleEndShape.serializeBinaryToWriter
    );
  }
  f = message.getDash();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.DashEndShape.serializeBinaryToWriter
    );
  }
};


/**
 * optional ArrowEndShape arrow = 1;
 * @return {?proto.vertexvis.protobuf.core.ArrowEndShape}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.getArrow = function() {
  return /** @type{?proto.vertexvis.protobuf.core.ArrowEndShape} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.ArrowEndShape, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.ArrowEndShape|undefined} value
 * @return {!proto.vertexvis.protobuf.core.EndShape} returns this
*/
proto.vertexvis.protobuf.core.EndShape.prototype.setArrow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.EndShape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.EndShape} returns this
 */
proto.vertexvis.protobuf.core.EndShape.prototype.clearArrow = function() {
  return this.setArrow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.hasArrow = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CircleEndShape circle = 2;
 * @return {?proto.vertexvis.protobuf.core.CircleEndShape}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.getCircle = function() {
  return /** @type{?proto.vertexvis.protobuf.core.CircleEndShape} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.CircleEndShape, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.CircleEndShape|undefined} value
 * @return {!proto.vertexvis.protobuf.core.EndShape} returns this
*/
proto.vertexvis.protobuf.core.EndShape.prototype.setCircle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.core.EndShape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.EndShape} returns this
 */
proto.vertexvis.protobuf.core.EndShape.prototype.clearCircle = function() {
  return this.setCircle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.hasCircle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DashEndShape dash = 3;
 * @return {?proto.vertexvis.protobuf.core.DashEndShape}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.getDash = function() {
  return /** @type{?proto.vertexvis.protobuf.core.DashEndShape} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.DashEndShape, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.DashEndShape|undefined} value
 * @return {!proto.vertexvis.protobuf.core.EndShape} returns this
*/
proto.vertexvis.protobuf.core.EndShape.prototype.setDash = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.vertexvis.protobuf.core.EndShape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.EndShape} returns this
 */
proto.vertexvis.protobuf.core.EndShape.prototype.clearDash = function() {
  return this.setDash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.EndShape.prototype.hasDash = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.ArrowEndShape.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.ArrowEndShape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.ArrowEndShape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ArrowEndShape.toObject = function(includeInstance, msg) {
  var f, obj = {
    width: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    filled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.ArrowEndShape}
 */
proto.vertexvis.protobuf.core.ArrowEndShape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.ArrowEndShape;
  return proto.vertexvis.protobuf.core.ArrowEndShape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.ArrowEndShape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.ArrowEndShape}
 */
proto.vertexvis.protobuf.core.ArrowEndShape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidth(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.ArrowEndShape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.ArrowEndShape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.ArrowEndShape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ArrowEndShape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getFilled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional double width = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.ArrowEndShape.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.ArrowEndShape} returns this
 */
proto.vertexvis.protobuf.core.ArrowEndShape.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool filled = 2;
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ArrowEndShape.prototype.getFilled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.core.ArrowEndShape} returns this
 */
proto.vertexvis.protobuf.core.ArrowEndShape.prototype.setFilled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.CircleEndShape.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.CircleEndShape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.CircleEndShape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CircleEndShape.toObject = function(includeInstance, msg) {
  var f, obj = {
    diameter: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    filled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.CircleEndShape}
 */
proto.vertexvis.protobuf.core.CircleEndShape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.CircleEndShape;
  return proto.vertexvis.protobuf.core.CircleEndShape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.CircleEndShape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.CircleEndShape}
 */
proto.vertexvis.protobuf.core.CircleEndShape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDiameter(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.CircleEndShape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.CircleEndShape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.CircleEndShape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.CircleEndShape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiameter();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getFilled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional double diameter = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.CircleEndShape.prototype.getDiameter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.CircleEndShape} returns this
 */
proto.vertexvis.protobuf.core.CircleEndShape.prototype.setDiameter = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool filled = 2;
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.CircleEndShape.prototype.getFilled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.core.CircleEndShape} returns this
 */
proto.vertexvis.protobuf.core.CircleEndShape.prototype.setFilled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.DashEndShape.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.DashEndShape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.DashEndShape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.DashEndShape.toObject = function(includeInstance, msg) {
  var f, obj = {
    width: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.DashEndShape}
 */
proto.vertexvis.protobuf.core.DashEndShape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.DashEndShape;
  return proto.vertexvis.protobuf.core.DashEndShape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.DashEndShape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.DashEndShape}
 */
proto.vertexvis.protobuf.core.DashEndShape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.DashEndShape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.DashEndShape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.DashEndShape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.DashEndShape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double width = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.DashEndShape.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.DashEndShape} returns this
 */
proto.vertexvis.protobuf.core.DashEndShape.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.FillStyle.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.FillStyle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.FillStyle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.FillStyle.toObject = function(includeInstance, msg) {
  var f, obj = {
    color: (f = msg.getColor()) && core_protos_material_pb.RGBAi.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.FillStyle}
 */
proto.vertexvis.protobuf.core.FillStyle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.FillStyle;
  return proto.vertexvis.protobuf.core.FillStyle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.FillStyle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.FillStyle}
 */
proto.vertexvis.protobuf.core.FillStyle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_material_pb.RGBAi;
      reader.readMessage(value,core_protos_material_pb.RGBAi.deserializeBinaryFromReader);
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.FillStyle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.FillStyle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.FillStyle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.FillStyle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_material_pb.RGBAi.serializeBinaryToWriter
    );
  }
};


/**
 * optional RGBAi color = 1;
 * @return {?proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.FillStyle.prototype.getColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBAi} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.RGBAi, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBAi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.FillStyle} returns this
*/
proto.vertexvis.protobuf.core.FillStyle.prototype.setColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.FillStyle} returns this
 */
proto.vertexvis.protobuf.core.FillStyle.prototype.clearColor = function() {
  return this.setColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.FillStyle.prototype.hasColor = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.StrokeStyle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.StrokeStyle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.StrokeStyle.toObject = function(includeInstance, msg) {
  var f, obj = {
    color: (f = msg.getColor()) && core_protos_material_pb.RGBAi.toObject(includeInstance, f),
    thickness: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.StrokeStyle}
 */
proto.vertexvis.protobuf.core.StrokeStyle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.StrokeStyle;
  return proto.vertexvis.protobuf.core.StrokeStyle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.StrokeStyle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.StrokeStyle}
 */
proto.vertexvis.protobuf.core.StrokeStyle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_material_pb.RGBAi;
      reader.readMessage(value,core_protos_material_pb.RGBAi.deserializeBinaryFromReader);
      msg.setColor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setThickness(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.StrokeStyle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.StrokeStyle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.StrokeStyle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_material_pb.RGBAi.serializeBinaryToWriter
    );
  }
  f = message.getThickness();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional RGBAi color = 1;
 * @return {?proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.getColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBAi} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.RGBAi, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBAi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.StrokeStyle} returns this
*/
proto.vertexvis.protobuf.core.StrokeStyle.prototype.setColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.StrokeStyle} returns this
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.clearColor = function() {
  return this.setColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.hasColor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double thickness = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.getThickness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.StrokeStyle} returns this
 */
proto.vertexvis.protobuf.core.StrokeStyle.prototype.setThickness = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
